import { GalleryContent } from './GalleryContent/GalleryContent'

import { MDBAnimation, MDBCard, MDBCardBody, MDBCardImage, MDBCardText, MDBCol, MDBContainer, MDBIcon, MDBPagination, MDBPaginationItem, MDBPaginationLink, MDBRipple, MDBRow } from "mdb-react-ui-kit"
import { useEffect, useState, createContext } from "react"
import { Link, Outlet } from 'react-router'

interface albumsModel {
    heading: string
    imgs: Array<string>
    date: string
    
}

const galleryDb: Array<albumsModel> = [
    {
        heading: 'Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank',
        imgs: [
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/1.jpeg',
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/2.jpeg',
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/3.jpeg',
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/4.jpeg',
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/5.jpeg',
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/6.jpeg',
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/7.jpeg',
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/8.jpeg',
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/9.jpeg',
            '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/10.jpeg',
        ],
        date: ''
    },
    {
        heading: 'Community Seed Bank Capacity-Building Workshop in Yilo Krobo Municipality',
        imgs: [
            '../../../../Community_Seed_Bank_Capacity_Building_Workshop_in_Yilo_Krobo_Municipality/1.jpeg',
            '../../../../Community_Seed_Bank_Capacity_Building_Workshop_in_Yilo_Krobo_Municipality/2.jpeg',
            '../../../../Community_Seed_Bank_Capacity_Building_Workshop_in_Yilo_Krobo_Municipality/3.jpeg',
        ],
        date: ''
    },
    {
        heading:'Training of farmers, stakeholders and executive committee members on conservation of root and tuber of Community Seed Banks',
        imgs: [
            '../../../../Training_of_farmers_stakeholders_and_executive_committee_members_on_conservation_of_root_and_tuber_of_Community_Seed_Banks/1.jpeg',
            '../../../../Training_of_farmers_stakeholders_and_executive_committee_members_on_conservation_of_root_and_tuber_of_Community_Seed_Banks/2.jpeg',
            '../../../../Training_of_farmers_stakeholders_and_executive_committee_members_on_conservation_of_root_and_tuber_of_Community_Seed_Banks/3.jpeg',
            '../../../../Training_of_farmers_stakeholders_and_executive_committee_members_on_conservation_of_root_and_tuber_of_Community_Seed_Banks/4.jpeg',
            '../../../../Training_of_farmers_stakeholders_and_executive_committee_members_on_conservation_of_root_and_tuber_of_Community_Seed_Banks/5.jpeg',
            '../../../../Training_of_farmers_stakeholders_and_executive_committee_members_on_conservation_of_root_and_tuber_of_Community_Seed_Banks/6.jpeg',
            '../../../../Training_of_farmers_stakeholders_and_executive_committee_members_on_conservation_of_root_and_tuber_of_Community_Seed_Banks/7.jpeg',
            '../../../../Training_of_farmers_stakeholders_and_executive_committee_members_on_conservation_of_root_and_tuber_of_Community_Seed_Banks/8.jpeg',
        ],
        date:''
    },
    {
        heading: 'Communal labour by the abrewankor community on the construction of the abrewankor community seed bank',
        imgs: [
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/1.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/2.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/3.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/4.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/5.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/6.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/7.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/8.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/9.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/10.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/11.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/12.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/13.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/14.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/15.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/16.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/17.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/18.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/19.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/20.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/21.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/22.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/23.jpeg',
            '../../../../communal_labour_by_the_abrewankor_community_on_the_construction_of_the_abrewankor_community_seed_bank/24.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'Community crop diversity wheel or the cells analysis at abrewankor community',
        imgs: [
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/1.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/2.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/3.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/4.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/5.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/6.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/7.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/8.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/9.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/10.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/11.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/12.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/13.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/14.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/15.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/16.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/17.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/18.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/19.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/20.jpeg',
            '../../../../community_crop_diversity_wheel_or_the_5_cells_analysis_at_abrewankor_community/21.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'Donation of exercise books and pens to learners and facilitators of abrewankor junior high school',
        imgs: [
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/1.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/2.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/3.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/4.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/5.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/6.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/7.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/8.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/9.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/10.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/11.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/12.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/13.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/14.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/15.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/16.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/17.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/18.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/19.jpeg',
            '../../../../donation_of_exercise_books_and_pens_to_learners_and_facilitators_of_abrewankor_junior_high_school/20.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'Launch of school group-biodiversity fun club at abrewankor basic school',
        imgs: [
            '../../../../launch_of_school_gro-biodiversity_fun_club_at_abrewankor_basic_school/1.jpeg',
            '../../../../launch_of_school_gro-biodiversity_fun_club_at_abrewankor_basic_school/2.jpeg',
            '../../../../launch_of_school_gro-biodiversity_fun_club_at_abrewankor_basic_school/3.jpeg',
            '../../../../launch_of_school_gro-biodiversity_fun_club_at_abrewankor_basic_school/4.jpeg',
            '../../../../launch_of_school_gro-biodiversity_fun_club_at_abrewankor_basic_school/5.jpeg',
            '../../../../launch_of_school_gro-biodiversity_fun_club_at_abrewankor_basic_school/6.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'Mangoase community seed bank',
        imgs: [
            '../../../../mangoase_community_seed_bank/1.jpeg',
        ],
        date: 'March 11, 2026'
    },

    { 
        heading: 'National agenda consultation meeting',
        imgs: [
            '../../../../national_agenda_consultation_meeting/1.jpeg',
        ],
        date: 'March 11, 2026'
    },

    { 
        heading: 'NUS network ghana consultation meeting on development of the national action agenda for neglected and underutilized_species (NUS) 28th Oct 2025 at CSIR-Food research institute gulf st.adamafio accra',
        imgs: [
            '../../../../NUS_network_ghana_consultation_meeting_on_development_of_the_national_action_agenda_for_neglected_and_underutilized_species_(NUS)_28th_Oct_2025_at_CSIR-Food_research_institute_gulf_st.adamafio_accra/1.jpeg',
            '../../../../NUS_network_ghana_consultation_meeting_on_development_of_the_national_action_agenda_for_neglected_and_underutilized_species_(NUS)_28th_Oct_2025_at_CSIR-Food_research_institute_gulf_st.adamafio_accra/2.jpeg',
            '../../../../NUS_network_ghana_consultation_meeting_on_development_of_the_national_action_agenda_for_neglected_and_underutilized_species_(NUS)_28th_Oct_2025_at_CSIR-Food_research_institute_gulf_st.adamafio_accra/3.jpeg',
            '../../../../NUS_network_ghana_consultation_meeting_on_development_of_the_national_action_agenda_for_neglected_and_underutilized_species_(NUS)_28th_Oct_2025_at_CSIR-Food_research_institute_gulf_st.adamafio_accra/4.jpeg',
            '../../../../NUS_network_ghana_consultation_meeting_on_development_of_the_national_action_agenda_for_neglected_and_underutilized_species_(NUS)_28th_Oct_2025_at_CSIR-Food_research_institute_gulf_st.adamafio_accra/5.jpeg',
            '../../../../NUS_network_ghana_consultation_meeting_on_development_of_the_national_action_agenda_for_neglected_and_underutilized_species_(NUS)_28th_Oct_2025_at_CSIR-Food_research_institute_gulf_st.adamafio_accra/6.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'NUS network ghana formally introducing the concept of abrewankor community seed bank and school agro-biodiversity fun club to abrewankor basic school leadership',
        imgs: [
            '../../../../NUS_network_ghana_formally_introducing_the_concept_of_abrewankor_community_seed_bank_and_school_agro-biodiversity_fun_club_to_abrewankor_basic_school_leadership/1.jpeg',
            '../../../../NUS_network_ghana_formally_introducing_the_concept_of_abrewankor_community_seed_bank_and_school_agro-biodiversity_fun_club_to_abrewankor_basic_school_leadership/2.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'Pictures of selected neglected and underutilized crop',
        imgs: [
            '../../../../pictures_of_selected_neglected_and_underutilized_crop/1.jpeg',
            '../../../../pictures_of_selected_neglected_and_underutilized_crop/2.jpeg',
            '../../../../pictures_of_selected_neglected_and_underutilized_crop/3.jpeg',

        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'Some staffs of the network',
        imgs: [
            '../../../../some_staffs_of_the_network/1.jpeg',
            '../../../../some_staffs_of_the_network/2.jpeg',
            '../../../../some_staffs_of_the_network/3.jpeg',
            '../../../../some_staffs_of_the_network/4.jpeg',
            '../../../../some_staffs_of_the_network/5.jpeg',
            '../../../../some_staffs_of_the_network/6.jpeg',
            '../../../../some_staffs_of_the_network/7.jpeg',
            '../../../../some_staffs_of_the_network/8.jpeg',
            '../../../../some_staffs_of_the_network/9.jpeg',
            '../../../../some_staffs_of_the_network/10.jpeg',
            '../../../../some_staffs_of_the_network/11.jpeg',
            '../../../../some_staffs_of_the_network/12.jpeg',
            '../../../../some_staffs_of_the_network/13.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'Technical working group from the embassy of the kingdom of the netherlands in ghana ministry of food and agriculture paid a working visit to mangoase community seed bank',
        imgs: [
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/1.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/2.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/3.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/4.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/5.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/6.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/7.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/8.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/9.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/10.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/11.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/12.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/13.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/14.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/15.jpeg',
            '../../../../technical_working_group_from_the_embassy_of_the_kingdom_of_the_netherlands_in_ghana_ministry_of_food_and_agriculture_paid_a_working_visit_to_mangoase_community_seed_bank/16.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'The eastern regional director of agriculture at the national agenda consultation meeting',
        imgs: [
            '../../../../the_eastern_regional_director_of_agriculture_at_the_national_agenda_consultation_meeting/1.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'The introduction of the community seed bank concept to the Nene and opinion leaders of abrewankor community',
        imgs: [
            '../../../../the_introduction_of_the_community_seed_bank_concept_to_the_Nene_and_opinion_leaders_of_abrewankor_community/1.jpeg',
            '../../../../the_introduction_of_the_community_seed_bank_concept_to_the_Nene_and_opinion_leaders_of_abrewankor_community/2.jpeg',
            '../../../../the_introduction_of_the_community_seed_bank_concept_to_the_Nene_and_opinion_leaders_of_abrewankor_community/3.jpeg',
        ],
        date: 'March 11, 2026'
    },

    {
        heading: 'Visitors from bangladesh and canada at mangoase community seed bank',
        imgs: [
            '../../../../visitors_from_bangladesh_and_canada_at_mangoase_community_seed_bank/1.jpeg',
            '../../../../visitors_from_bangladesh_and_canada_at_mangoase_community_seed_bank/2.jpeg',
            '../../../../visitors_from_bangladesh_and_canada_at_mangoase_community_seed_bank/3.jpeg',
            '../../../../visitors_from_bangladesh_and_canada_at_mangoase_community_seed_bank/4.jpeg',
            '../../../../visitors_from_bangladesh_and_canada_at_mangoase_community_seed_bank/5.jpeg',
            '../../../../visitors_from_bangladesh_and_canada_at_mangoase_community_seed_bank/6.jpeg',
        ],
        date: 'March 11, 2026'
    },
]

interface newsContext {

    news: Array<Array<albumsModel>> | undefined
    newsList: Array<albumsModel> | undefined
    pageHandler: (index: number) => void
    index: number | undefined
    pager: Array<Array<number>> | undefined
    pagerList: Array<number> | undefined
    pagerIndex: number | undefined

    pageBack: () => void

    pageForward: () => void

}

export const GalleryContext = createContext<newsContext | undefined>(undefined)


export const Gallery = () => {

    let st: number = 0

    let en: number = 9

    let totalPages: number = Math.ceil(galleryDb.length / en)

    let news: Array<Array<albumsModel>> = []

    const [news_, setNews_] = useState<Array<Array<albumsModel>> | undefined>(news)

    let newsList: Array<albumsModel> = []

    const [newsList_, setNewsList_] = useState<Array<albumsModel> | undefined>(newsList)

    const [index, setIndex] = useState<number | undefined>(0)

    useEffect(() => {

        Array.from({ length: totalPages }).map(
            (_, index) => {
                let n = galleryDb.slice(st, en)

                news.push(n)

                st = st + 9
                en = en + 9

            }
        )

        setNews_(news)

        return () => {

            news = []

        }

    }, [galleryDb])



    useEffect(() => {

        if (news_ === undefined) {
            return
        }

        if (index === undefined) {
            return
        }

        let newsList__ = news_[index]

        setNewsList_(newsList__)

        return () => {

            newsList__ = []
        }

    }, [index])


    const pagingHandler = (index: number) => {

        setIndex(index)

    }

    // pager
    const pager: Array<Array<number>> = []

    const [pager_, setPager_] = useState<Array<Array<number>> | undefined>(pager)

    useEffect(() => {

        // pagingList
        const pagingList: Array<number> = []

        if (news_ === undefined) {
            return
        }

        Array.from({ length: news_.length }).map(
            (_, index) => {
                pagingList.push(index + 1)
            }
        )

        const pagerLength: number = Math.ceil(pagingList.length / 9)

        let st_ = 0

        let en_ = 9

        Array.from({ length: pagerLength }).map(
            (_, val) => {

                let n = pagingList.slice(st_, en_)

                pager.push(n)

                st_ = st_ + 9

                en_ = en_ + 9
            }
        )

        setPager_(pager)

    }, [news_])

    const [pagerIndex, setPagerIndex] = useState<number | undefined>(0)

    const pagerList: Array<number> = []

    const [pagerList_, setPagerList_] = useState<Array<number> | undefined>(pagerList)

    useEffect(() => {

        if (pager_ === undefined) {
            return
        }

        if (pagerIndex === undefined) {
            return
        }

        const n = pager_[pagerIndex]

        setPagerList_(n)

    }, [pagerIndex])

    // pagerBack
    const pagerBack = () => {

        if (pagerIndex === undefined) {
            return
        }

        setPagerIndex(pagerIndex - 1)

    }

    // pagerForward
    const pagerForward = () => {

        if (pagerIndex === undefined) {
            return
        }

        setPagerIndex(pagerIndex + 1)
    }

    return (
        <>
            <GalleryContext.Provider value={{ news: news_, newsList: newsList_, pageHandler: pagingHandler, index: index, pager: pager_, pagerList: pagerList_, pagerIndex: pagerIndex, pageBack: pagerBack, pageForward: pagerForward }}>
                <Outlet />
            </GalleryContext.Provider>
        </>
    )
}